import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/nova/components/Icon/Icon';
import { isOpenableHttpUrl } from '../../url-safety';
import { Root } from './OpenUrlButton.styles';

export type OpenUrlButtonProps = {
  /** The URL to open. The button renders only when this is an absolute http(s) URL. */
  url: string;
};

/**
 * A bare icon button that opens an absolute URL in a new tab (noopener). Rendered as the
 * trailing action inside a URL Field; it appears ONLY when the field holds a valid absolute
 * http(s) URL, so an empty or relative value shows nothing to click.
 */
export const OpenUrlButton = ({ url }: OpenUrlButtonProps): React.ReactElement | null => {
  const { t } = useTranslation();
  const trimmed = url.trim();
  if (!isOpenableHttpUrl(trimmed)) return null;

  const onClick = (): void => {
    window.open(trimmed, '_blank', 'noopener,noreferrer');
  };

  return (
    <Root type="button" aria-label={t('Open link in a new tab')} onClick={onClick}>
      <Icon name="external-link" size={16} />
    </Root>
  );
};

export default OpenUrlButton;
